import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, OnChanges, SimpleChanges } from "@angular/core";
import { ChangeDetectorRef } from '@angular/core';
import * as moment from 'moment-timezone';


import { SessionHelper } from "../../core/helper/sessionHelper";
import { A3LCompany } from "../../core/models/a3LCompany.model";
import { A3LCompanyService } from "../../core/services/a3LCompany.service";
import { ISelector } from "../../components/filters//interfaz/ISelector";

import { AppEmpresas } from "../../core/models/appEmpresas.model";
import { AppEmpresasService } from "../../core/services/appEmpresasService.service";

import { AppUsuario } from '../../core/models/appUsuario.model';
import { AppUsuarioService } from '../../core/services/appUsuarioService.service';

import { UserService } from "../../core/services/user.service";
import { User } from "../../core/models/user.model";

import { AppSeccion } from '../../core/models/appSeccion.model';
import { AppSeccionesService } from "../../core/services/appSeccionesService.service";

import { AppCategorias } from "../../core/models/appCategorias.model";
import { AppCategoriasService } from "../../core/services/appCategorias.service";

import { AppA3DocCategory } from "../../core/models/appA3DocCategory.model";
import { AppA3DocService } from "../../core/services/appA3Doc.service";

import { formatCategoryTree } from "../helpers/formatCategoryTree.js"

import { AppWorkCentersService } from "../../core/services/appWorkCentersService.service";
import { AppAttendanceTypes } from "../../core/models/appAttendanceTypes.model";
import { AppAttendanceService } from "../../core/services/appAttendanceService.service";
import { AppAttendanceTypesService } from "../../core/services/appAttendanceTypesService.service";
import { HttpParams } from "@angular/common/http";
import { AppWorkCenters } from "../../core/models/appWorkCenters.model";
import { AppCostCentersService } from "../../core/services/appCostCentersService.service";
import { AppCostCenters } from "../../core/models/appCostCenter.model";
import { LivesSessionHelper } from "../../core/helper/livesSessionHelper";
import { LicenseCheckerService } from "../../core/helper/licenseChecker";

@Component({
  selector: 'app-dropdown-formularios',
  templateUrl: './dropdown-formularios.component.html',
  styleUrls: ['./dropdown-formularios.component.scss'],
  providers: [AppEmpresasService, AppUsuarioService, AppSeccionesService, AppCategoriasService, UserService, AppA3DocService, AppAttendanceService, AppCostCentersService]
})
export class DropdownFormulariosComponent implements OnInit, OnChanges, ISelector<AppEmpresas>, OnDestroy {

  constructor(
    private companyService: AppEmpresasService,
    private userService: AppUsuarioService,
    private usersInorcaService: UserService,
    private sectionsService: AppSeccionesService,
    private costCentersService: AppCostCentersService,
    private categoriesService: AppCategoriasService,
    private appA3DocService: AppA3DocService,
    private appWorkCentersService: AppWorkCentersService,
    private appAttendanceTypesService: AppAttendanceTypesService,
    private sessionHelper: SessionHelper,
    private cdr: ChangeDetectorRef,
    private _livesSession: LivesSessionHelper,
    private licenseChecker: LicenseCheckerService
  ) {
    setTimeout(() => this.getEntities(), 1000);
  }


  disabledState: boolean = false;
  entities: AppEmpresas[];
  yesNoOptions: any[] = [{ 'value': 'true', 'name': 'Sí', }, { 'value': 'false', 'name': 'No', }];
  entryOptions: any[] = [{ 'value': 'true', 'name': 'Entrada', }, { 'value': 'false', 'name': 'Salida', }];
  attendanceViewOptions: any[] = [{ 'value': '0', 'name': 'POR DÍA', }, { 'value': '1', 'name': 'POR REGISTRO', }];
  attendanceTypeOptions: AppAttendanceTypes[];
  timeZonesOptions: any[];
  innuvaWorkCenterOptions: any[];
  workCenterOptions: any[];
  optionsNull: boolean = false;
  users: AppUsuario[];
  netUsers: User[];
  hrUsers: User[];
  sections: AppSeccion[];
  categories: AppCategorias[];
  categoriesA3Doc: AppA3DocCategory[];
  companies: AppEmpresas[];
  workCenters: AppWorkCenters[];
  costCenters: AppCostCenters[];
  value: any;
  environmentID = this._livesSession.EnvironmentId;
  originalCategory: string;
  companySelectedValue: string;



  selectedItems = [];
  flatCategories = null;
  selectedItemsNumbers = [];
  isTreeBoxOpened = false;

  @Output() selectedValueChange = new EventEmitter<any>();
  @Output() selectedValueData = new EventEmitter<any>();
  @Output() categoriesLoaded = new EventEmitter<void>();


  @Input() emptyOption: false;
  @Input() selectedValue: number | string;
  @Input() selectedArrayValue: (number | string)[] = [];
  @Input() placeHolder: string = '';
  @Input() dataSize: number = 7;
  @Input() required: boolean;
  @Input() multiple: boolean;
  @Input() disabled: boolean;
  @Input() onlyConfigured: boolean = false;
  @Input() dropdownType: string;
  @Input() filteredName: string = null;
  @Input() selectedId: string;
  @Input() isDisabled: boolean = false;
  @Input() id: string;
  @Input() notSelectableId: number[];
  @Input() getCompanyCode: boolean = false;
  @Input() section: string = null;
  @Input() companySelected: string = null;
  @Input() detailedData: boolean = false;
  @Input() smallA3Doc: boolean = false;
  @Input() companyData: any;
  @Input() configuredWorkCenterCodes: Number[] = [];
  @Input() netUsersData: any[];




  loading: boolean = false;

  isLoading = true;

  getEntities() {
    this.loading = true;

    //this.getFromLocalStorage();



    this.companyService.getAllModelsByEnvironment(this.environmentID).subscribe((response: AppEmpresas[]) => {
      if (response) {
        this.entities = response;
        this.safeOnLocalStorage();
      }
      this.loading = false;
    }, error => {
      this.loading = false;
      console.error(error)
    });
  }

  getYesNo() {
    this.yesNoOptions = [{ 'value': 'true', 'name': 'Sí', }, { 'value': 'false', 'name': 'No', }];
    /*  this.selectedValueChange.emit(null); */
  }

  getPayRollType() {
    this.yesNoOptions = [{ 'value': 'true', 'name': 'Fecha Antigüedad ', }, { 'value': 'false', 'name': 'Fecha Antigüedad en la empresa', }];
    this.selectedValueChange.emit(null);
  }

  //USUARIOS



  getUsers(company: any, notSelectableId?: any) {
    this.loading = true;

    this.userService.getAllForSelectByCompany(company, true).subscribe((response: AppUsuario[]) => {
      if (response) {
        this.users = response;

        // Filtramos los usuarios, excluyendo aquellos cuyo user1 está en notSelectableId
        if (notSelectableId) {
          this.users = response.filter(user => !notSelectableId.includes(user.user1));
        } else {
          this.users = response;
        }

        // Si existe `this.section`, filtramos por sección
        if (this.section) {
          this.users = this.users.filter(user => user.section?.section1 !== this.section);
        }
        // this.safeOnLocalStorage();
      }
      this.loading = false;
    }, error => {
      this.loading = false;
      console.error(error)
    })
  }

  getHRUsers(netUsersData: any) {
    this.loading = true;
    this.usersInorcaService.getAllModels().subscribe((response: User[]) => {
      if (response) {
        this.hrUsers = response.filter(user =>
          netUsersData?.some(nd => user.Id === nd)
        );
        this.safeOnLocalStorage();
      }
      this.loading = false;
    }, error => {
      this.loading = false;
      console.error(error)
    });
  }

  getNetUsers(company: any) {
    this.loading = true;

    this.usersInorcaService.getAllModels().subscribe((response: User[]) => {
      if (response) {
        this.netUsers = response;
        this.safeOnLocalStorage();
      }
      this.loading = false;
    }, error => {
      this.loading = false;
      console.error(error)
    });
  }

  //se usa en el componente para mostrar el formato Nombre (NIF)
  getNameWithNif(user: any): string {
    return `${user.Name} (${user.Nif})`;
  }

  //SECCIONES

  getSections(company: any) {
    this.loading = true;

    this.sectionsService.getAllModelsByCompany(company).subscribe((response: AppSeccion[]) => {
      if (response) {
        // Filtrar las secciones que no tienen parent null
        this.sections = response.filter(section => section.parent !== null);
        this.safeOnLocalStorage();
      }
      this.loading = false;
    }, error => {
      this.loading = false;
      console.error(error);
    });
  }


  //CATEGORIAS

  getCategories(filteredName = null) {
    this.loading = true;
    const categoriesObservable = filteredName
      ? this.categoriesService.getAllModelsFilteredName(filteredName)
      : this.categoriesService.getAllModels();

    categoriesObservable.subscribe((response: AppCategorias[]) => {
      if (response) {
        this.categories = response;
        this.safeOnLocalStorage();
      }
      this.loading = false;
    }, error => {
      this.loading = false;
      console.error(error);
    });
  }


  getCategoriesA3doc() {
    // A3DOC

    this.appA3DocService.getCategoriesTree().then(
      data => {
        this.categoriesA3Doc = formatCategoryTree(this.appA3DocService.deleteCategoryTreesByIds(data.tree));
        this.flatCategories = this.flattenCategories(this.categoriesA3Doc);

        // Si hay valores en selectedArrayValue, seleccionarlos
        if (this.selectedArrayValue && this.selectedArrayValue.length > 0) {
          this.selectedItems = this.flatCategories.filter(cat =>
            this.selectedArrayValue.includes(cat.id)
          );
          this.selectedItemsNumbers = this.selectedItems.map(item => item.id);
        }
        this.categoriesLoaded.emit();
        this.isLoading = false;
      },
      error => {
        console.error('Error getCategoriesTree:', error); // 
      }
    );
  }


  onTreeViewContentReady(e: any) {
    this.selectedItemsNumbers.forEach(id => {
      e.component.selectItem(id);
    });
  }


  //EMPRESAS
  private async loadUserCompanies(): Promise<string[]> {
    try {
      let loggedUserCompanies: string[] = [];
      const result = await this.companyService.getHrValidatorCompaniesIds(this._livesSession.AspNetUserId).toPromise();
      result.companies.map((company) => {
        if (company.company1) {
          loggedUserCompanies.push(company.company1);
        }
      });
      return loggedUserCompanies
    } catch (error) {
      console.error(`Error getHrValidatorCompaniesIds`, error);
    }
  }

  async getCompanies() {
    this.loading = true;

    try {
      const userCompanies = await this.loadUserCompanies();
      const livesLicense = this.licenseChecker.checkLicense('livesHR');

      this.companyService.getAllModelsByEnvironment(this.environmentID).subscribe((response: AppEmpresas[]) => {
        if (response) {
          // Filtramos las empresas manteniendo el tipo AppEmpresas

          if (livesLicense) {
            this.companies = response.filter(company => userCompanies.includes(company.company1));
          } else {
            this.companies = response
          }

          // Mapeamos para obtener id, name y nif de manera separada
          const companyData = this.companies.map(company => ({
            id: company.company1,
            name: company.name,
            companyCode: company.companyCode,
            nif: company.identifierNumber
          }));
          this.selectedValueData.emit(companyData);
          this.safeOnLocalStorage();
        }
        this.loading = false;
      }, error => {
        this.loading = false;
        console.error(error);
      });
    } catch (error) {
      this.loading = false;
      console.error('Error loading user companies', error);
    }
  }

  //CENTROS DE TRABAJO DE INNUVA
  async getInnuvaWorkCenters() {
    this.loading = true;

    try {
      this.appWorkCentersService.getInnuvaWorkCenters({ companyCode: this.companyData.companyCode, companyId: this.companyData.company1 }).subscribe((response: any) => {
        if (response) {
          this.innuvaWorkCenterOptions = response
            .filter((item: any) => !this.configuredWorkCenterCodes.includes(item.workplaceCode))
            .map((item: any) => ({
              value: item.workplaceCode,
              name: item.workplaceName,
              fullValue: { value: item.workplaceCode, name: item.workplaceName }
            }));

          if (this.innuvaWorkCenterOptions.length === 0 || !this.innuvaWorkCenterOptions) {
            this.optionsNull = true;
          } else {
            this.optionsNull = false
          }

          this.safeOnLocalStorage();
        }
        this.loading = false;
      }, error => {
        this.loading = false;
        console.error(error);
      });
    } catch (error) {
      this.loading = false;
      console.error('Error loading innuva workcenters', error);
    }
  }

  //CENTROS DE TRABAJO 
  async getWorkCenters() {
    this.loading = true;

    try {
      this.appWorkCentersService.getWorkCenters({ companyId: this.companyData.company1 }).subscribe((response: any) => {
        if (response) {
          this.workCenters = response[this.companyData.company1]
          this.workCenterOptions = response[this.companyData.company1]
            ? response[this.companyData.company1]
              .filter(item => item.enabled === true)
              .map(item => ({
                value: item.workCenter1,
                name: item.name
              }))
            : [];

          if (this.workCenterOptions.length === 0 || !this.workCenterOptions) {
            this.optionsNull = true
          }
          else {
            this.optionsNull = false
          }
          this.safeOnLocalStorage();
        }
        this.loading = false;
      }, error => {
        this.loading = false;
        console.error(error);
      });
    } catch (error) {
      this.loading = false;
      console.error('Error loading innuva workcenters', error);
    }
  }

  //TIPOS DE MARCAJE
  async getAttendanceTypes() {
    this.loading = true;
    try {
      const params = new HttpParams().set('enabled', 'true')
      this.appAttendanceTypesService.getAllModels(this.companyData.company1, params).subscribe((response: any) => {
        if (response) {
          this.attendanceTypeOptions = response[this.companyData.company1]
            ? response[this.companyData.company1].map(item => ({
              value: item.attendanceType1,
              name: item.name
            }))
            : [];

          if (this.attendanceTypeOptions.length === 0 || !this.attendanceTypeOptions) {
            this.optionsNull = true
          }
          else {
            this.optionsNull = false
          }
        }
        this.loading = false;
      }, error => {
        this.loading = false;
        console.error(error);
      });
    } catch (error) {
      this.loading = false;
      console.error('Error loading attendance types', error);
    }
  }

  //ZONAS HORARIAS

  getTimeZones() {
    this.loading = true;
    this.timeZonesOptions = moment.tz.names().map(tz => ({ name: tz, value: tz }));
    this.loading = false;
  }

  //COST CENTERS DE INNUVA

  getCostCenters() {
    this.loading = true;

    this.costCentersService.getAllModels().subscribe((response: AppCostCenters[]) => {
      if (response) {
        // Usar reduce para aplanar los arrays
        this.costCenters = response.reduce((acc, company) => {
          company.costCenters.forEach(costCenter => {
            acc.push({
              imputationGuid: costCenter.imputationGuid,
              imputationCode: costCenter.imputationCode,
              imputationName: `${costCenter.imputationName} (${company.companyName})`,
              companyName: company.companyName,
              company1: company.company1,
              companyCode: company.companyCode,
              environment: company.environment
            });
          });
          return acc;
        }, []);

        this.safeOnLocalStorage();
      }
      this.loading = false;
      this.onSelectedValueChangeCostCenter(this.selectedValue)
    }, error => {
      this.loading = false;
      console.error(error);
    });
  }


  private safeOnLocalStorage() {
    localStorage.setItem(this.getKeyLocalStorage(), JSON.stringify(this.entities));
  }

  private getFromLocalStorage() {
    /* const companies = localStorage.getItem(this.getKeyLocalStorage()); */
    this.companyService.getAllModelsByEnvironment(this.environmentID).subscribe(
      (companies: AppEmpresas[]) => {
        this.entities = companies;
        this.loading = false;
      },
      error => {
        console.error(error);
        console.error("Failed to fetch companies");
        this.loading = false;
      }
    );
  }

  private getKeyLocalStorage(): string {
    return `companies${this.sessionHelper.User.IdCliente}OnlyConfigured=${String(this.onlyConfigured)}`;
  }

  ngOnInit() {
    if (this.dropdownType == 'YesNo') {
      this.getYesNo();
    }

    if (this.dropdownType == 'Users') {
      this.getUsers(this.id)
    }

    if (this.dropdownType == 'HRUsers') {
      this.getHRUsers(this.netUsersData)
    }

    if (this.dropdownType == 'NetUsers') {
      this.getNetUsers(this.id)
    }

    if (this.dropdownType == 'HolidayBagUsers') {
      this.getHRUsers(this.netUsersData)
    }

    if (this.dropdownType == 'Section') {
      this.getSections(this.id)
    }

    if (this.dropdownType === 'DocCategories') {
      // this.getCategories(this.filteredName || null);
      this.getCategoriesA3doc()
      this.originalCategory = this.selectedValue?.toString();
    }

    if (this.dropdownType == 'PayRollType') {
      this.getPayRollType()
    }

    if (this.dropdownType == 'Companies') {
      this.getCompanies()
    }

    if (this.dropdownType == 'InnuvaWorkCenter') {
      this.getInnuvaWorkCenters()
    }

    if (this.dropdownType == 'WorkCenter') {
      this.getWorkCenters()
    }

    if (this.dropdownType == 'AttendanceType') {
      this.getAttendanceTypes()
    }

    if (this.dropdownType == 'TimeZone') {
      this.getTimeZones()
    }

    if (this.dropdownType == 'CostCenters') {
      this.getCostCenters()
    }



  }

  onSelectedValueChange(event) {
    if (event) {
      //this.selectedValue = event;
      this.selectedValueChange.emit(event);
    }
  }

  onSelectedValueChangeYesNo(event) {

    if (event && event !== 'undefined') {
      //this.selectedValue = event;
      this.selectedValueChange.emit(event);
    }
  }

  onSelectedValueChangEntry(event) {

    if (event && event !== 'undefined') {
      //this.selectedValue = event;
      this.selectedValueChange.emit(event);
    }
  }

  onSelectedValueChangePayRoll(event) {

    if (event && event !== 'undefined') {
      //this.selectedValue = event;
      this.selectedValueChange.emit(event);
    }
  }

  onSelectedValueChangeHolidayBagValidator(event) {

    if (typeof event === 'string') {
      event = event
    }

    if (event && this.disabledState == false) {
      //this.selectedValue = event;
      this.selectedValueChange.emit(event);
    }
  }

  onSelectedValueChangeNetUsers(event) {

    if (typeof event === 'string') {
      event = [event]
    }

    if (event && this.disabledState == false) {
      //this.selectedValue = event;
      this.selectedValueChange.emit(event);
    }
  }

  onSelectedValueChangeHRValidator(event) {

    if (typeof event === 'string') {
      event = [event]
    }

    if (event && this.disabledState == false) {
      //this.selectedValue = event;
      this.selectedValueChange.emit(event);
    }
  }


  onSelectedValueChangeUsers(event: any, emitDetailedData: boolean = false) {
    if (event && this.disabledState == false) {
      const selectedUser = this.users.find(user => user.user1 === event);
      if (emitDetailedData && selectedUser) {
        // Emite un objeto con detalles del usuario
        this.selectedValueChange.emit(selectedUser);
      } else {
        // Emite solo el ID si no se requiere `emitDetailedData`
        this.selectedValueChange.emit(event);
      }
    }
  }


  onSelectedValueChangeSection(event) {
    if (event && event != undefined) {
      //this.selectedValue = event;

      this.selectedValueChange.emit(event);

    }
  }

  onSelectedValueChangeCompanies(event: any, multiple: boolean, emitDetailedData: boolean = false) {

    if (this.emptyOption) {
      this.selectedValueChange.emit(event);
      return;
    }

    if (event && event !== undefined) {
      let selectedCompanies = [];

      if (multiple && Array.isArray(event)) {

        selectedCompanies = event.map(selectedId => {
          const company = this.companies.find(comp => comp.company1 === selectedId || comp.companyCode === selectedId);

          if (emitDetailedData) {
            return company ? {
              id: company.company1,
              nif: company.identifierNumber,
              companyCode: company.companyCode,
              name: company.name
            } : null;
          } else {
            // Si emitDetailedData es falso, devuelve solo el id 
            return company ? company.company1 : null;
          }
        }).filter(company => company !== null);
      } else {
        const company = this.companies.find(comp => comp.company1 === event || comp.companyCode === event);

        if (company) {
          if (emitDetailedData) {
            selectedCompanies = [{
              id: company.company1,
              nif: company.identifierNumber,
              companyCode: company.companyCode,
              name: company.name,
              appId: company.appId,
            }];
          } else {
            selectedCompanies = [company.company1];
          }
        }
      }
      // Emitimos los valores seleccionados dependiendo del parámetro emitDetailedData
      this.selectedValueChange.emit(selectedCompanies);
    }
  }



  onSelectedValueChangeDocCategories(event) {
    if (event !== null && event !== this.originalCategory) {
      this.selectedValueChange.emit(event);
    }
  }

  onSelectedValueChangeInnuvaWorkCenter(event) {
    if (event !== null) {
      this.selectedValueChange.emit(event);
    }
  }

  onSelectedValueChangeWorkCenter(event: any, emitDetailedData: boolean = false) {
    if (event && this.disabledState == false) {
      const selectedWorkCenter = this.workCenters.find(workCenter => workCenter.workCenter1 === event);
      if (emitDetailedData && selectedWorkCenter) {
        this.selectedValueChange.emit(selectedWorkCenter);
      } else {
        // Emite solo el ID si no se requiere `emitDetailedData`
        this.selectedValueChange.emit(event);
      }
    }
  }

  onSelectedValueChangeAttendanceView(event) {
    if (event !== null) {
      this.selectedValueChange.emit(event);
    }
  }

  onSelectedValueChangeAttendanceType(event) {

    if (event !== null) {
      this.selectedValueChange.emit(event);
    }
  }

  onSelectedValueChangeCostCenter(event) {
    if (event !== null) {


      if (typeof event === 'object') {
        const matchingCostCenter = this.costCenters.find(costCenter =>
          costCenter.imputationCode === event.imputationCode &&
          costCenter.company1 === event.company1 &&
          costCenter.companyCode === event.companyCode &&
          costCenter.environment === event.environment
        );

        if (matchingCostCenter) {
          this.selectedValue = matchingCostCenter.imputationGuid;
          this.selectedValueChange.emit(matchingCostCenter);
        } else {
          this.selectedValue = null;
          this.selectedValueChange.emit(null);
        }
      } else {
        const selectedCostCenter = this.costCenters.find(costCenter => costCenter.imputationGuid === event);
        this.selectedValue = event;
        this.selectedValueChange.emit(selectedCostCenter);
      }
    }
  }





  onSelectionChanged(event) {
    let selectedNodes = event.component.getSelectedNodes();

    // Mapear los nodos seleccionados para obtener id y name
    this.selectedItems = selectedNodes.map(node => ({
      id: node.itemData.id,
      name: node.itemData.name,
    }));

    // Actualizar la cadena de nombres concatenados
    this.selectedItemsNumbers = this.selectedItems.map(item => item.id);
    this.isTreeBoxOpened = false
    // Emitir el cambio si es necesario
    this.selectedValueChange.emit(this.selectedItems);
  }

  onTreeBoxOptionChanged(e) {
    if (e.name === 'value') {
      this.isTreeBoxOpened = false;
      this.cdr.detectChanges();
    }
  }


  flattenCategories(data) {
    let flatData = [];
    data.forEach(node => {
      flatData.push({
        id: node.id,
        name: node.name,
        parentId: node.parentId
      });
      // Si tiene hijos, aplanarlos recursivamente
      if (node.items) {
        flatData = flatData.concat(this.flattenCategories(node.items));
      }
    });
    return flatData;
  }


  ngOnChanges(changes: SimpleChanges) {



    if (changes['disabled']) {
      this.disabled = changes['disabled'].currentValue;
    }

    if (changes['isDisabled']) {
      this.disabledState = changes['isDisabled'].currentValue;
    }
    if (changes.selectedId && changes.selectedId.currentValue !== undefined) {
      this.selectedValue = changes.selectedId.currentValue;
    }

    if (changes['id'] && this.dropdownType == 'NetUsers') {
      this.getNetUsers(this.id)
    }

    if ((changes['id'] || changes['netUsersData']) && this.dropdownType == 'HRUsers') {
      this.getHRUsers(this.netUsersData)
    }

    if ((changes['id'] || changes['netUsersData']) && this.dropdownType == 'HolidayBagUsers') {
      this.getHRUsers(this.netUsersData)
    }

    if (changes['id'] && this.dropdownType == 'Users') {
      this.getUsers(this.id)
    }

    if (changes['notSelectableId'] && this.dropdownType == 'Users') {
      this.getUsers(this.id, this.notSelectableId)
    }

    if (changes['id'] && this.dropdownType == 'Section') {
      this.getSections(this.id)
    }

    if (changes['companyData'] && this.dropdownType == 'AttendanceType') {
      this.getAttendanceTypes()
    }

    if (changes['companyData'] && this.dropdownType == 'WorkCenter') {
      this.getWorkCenters()
    }

    this.onSelectedValueChangeSection(this.selectedValue);

  }



  ngOnDestroy(): void {
    this.selectedValueChange = undefined;
  }

}